/**
 * Centralized dynamic state for the public signup form page.
 */

/** @typedef {{
 *   country: string,
 *   currency: string,
 *   lastFetchedTaxId: string,
 *   onboardingId: string,
 *   contactEmail: string,
 * }} SignupFormState */

/** @type {SignupFormState} */
const state = {
  country: "BR",
  currency: "",
  lastFetchedTaxId: "",
  onboardingId: "",
  contactEmail: "",
};

/**
 * @returns {Readonly<SignupFormState>}
 */
export function getSignupState() {
  return state;
}

/**
 * @param {Partial<SignupFormState>} patch
 */
export function patchSignupState(patch) {
  Object.assign(state, patch);
}
